module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hs4ff"))).then(() => parcelRequire('ikE14'));